import { jsx as i } from "react/jsx-runtime";
import { StyledPickersDay as y } from "./styles7.mjs";
import a from "./index214.mjs";
const u = (t) => {
  const { day: o, outsideCurrentMonth: r, ...n } = t, s = !r && a(o);
  return /* @__PURE__ */ i(
    y,
    {
      ...n,
      day: o,
      outsideCurrentMonth: r,
      $isSunday: s
    }
  );
};
export {
  u as Day
};
//# sourceMappingURL=Day.mjs.map
